import React from 'react'
import PropTypes from 'prop-types'

export default class CheckoutElementContainer extends React.Component {
  static propTypes = {
    element: PropTypes.element.isRequired,
    title: PropTypes.string.isRequired,
    bold: PropTypes.bool.isRequired,
  }

  weightedTitle(boldBool, title) {
    if (boldBool) {
      return <h4 className="font-weight-bold mb-5">{title}</h4>
    } else {
      return <h4 className="font-weight-lighter mb-5">{title}</h4>
    }
  }

  render() {
    return (
      <div className="w-100 p-4 text-left">
        {this.weightedTitle(this.props.bold, this.props.title)}
        {this.props.element}
      </div>
    )
  }
}
